(function () {
    var ClientSelectorCtrl = (function () {
        function ClientSelectorCtrl() {               
            this.init.apply(this, arguments);
        }

        ClientSelectorCtrl.prototype = {
            init: function ($scope, $mdDialog, MKioskService, $timeout, $mdPanel, $q, $timeout, $translationService, client, options) {            
                $scope.vm = this;
                this.$scope = $scope;
                this.$mdDialog = $mdDialog;
                this.MKioskService = MKioskService;                
                this.$timeout = $timeout;
                this.$mdPanel = $mdPanel;
                this.$q = $q;
                this.$timeout = $timeout;
                this.$translationService = $translationService;

                this.selectOnly;                
                this.client;
             
                this.$timeout = $timeout;                       
                
                this.client = client;
                this.optional = options.optional;
                this.selectOnly = options.selectOnly;

                var _this = this;
                this.querySearch = "";
                this.clients = [];
                this.getData().then(function (clients) {
                    _this.clients = clients;
                });
            },
            bindEvents: function () {
                var _this = this;
                //hide panel when close client
                this.$scope.$on("$destroy", function () {
                    if (_this.MdPanelRef)
                        _this.MdPanelRef.close();
                });

                var _this = this;
                this.$element.find('.keysearch').on("focus", function () {
                    $(this).attr("placeholder", _this.$translationService.getTranslation('Search'));
                    $(this).unbind('focus');
                    _this.$element.find('.block-title').hide();
                    _this.$element.find('.input-search-container').addClass('show-full-input');
                });

                this.$element.resize(function () {
                    var controller = _this.$element.find("md-virtual-repeat-container").data("$mdVirtualRepeatContainerController");
                    controller.updateSize();
                });
            },
            ready: function () {
                this.$element = $("#internal-clientsselector-v2-page");
                this.bindEvents();
            },
            getData: function () {
                return this.MKioskService.getClients();
            },
            filter: function (keysearch) {
                return this.MKioskService.getClients(keysearch).then(angular.bind(this, function (clients) {
                    this.clients.splice(0, this.clients.length);
                    _.each(clients, function (client) {
                        this.clients.push(client);
                    }, this);

                    //Scroll to top and update content
                    var controller = this.$element.find("md-virtual-repeat-container").data("$mdVirtualRepeatContainerController");
                    controller.resetScroll();
                }));

            },
            clearSearch: function () {
                this.querySearch = "";
                this.startSearch();
            },
            goBack: function () {
                this.$mdDialog.cancel();
            },
            startSearch: function () {
                this.filter(this.querySearch);
            },
            selectClient: function (client) {
                this.$scope['selectedClient'] = client; // this is for opening by panel to get back the selected client

                if (this.mdPanelRef) {
                    this.mdPanelRef.close(client);
                } else {
                    this.$mdDialog.hide(client);
                }
            },
            showClientDialog: function (options) {
                var config = {
                    attachTo: angular.element(document.body),
                    controller: 'AddClientV2Ctrl',
                    templateUrl: 'js/internal/addclient-v2/addclient.view.html',
                    targetEvent: options.$event,
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    focusOnOpen: true,
                    panelClass: 'addclient-v2-panel',
                    hasBackdrop: true,
                    zIndex: 90,
                    locals: {
                        onClose: function (client) {
                            if(client){
                                _.extend(options.client, client);
                            }
                        },
                        client: options.client,
                        prevRouter: options.prevRouter
                    },
                    onDomAdded: function () {
                        $(".addclient-v2-panel").parent().addClass("addclient-v2-panel-container");
                    }
                };
                this.MdPanelRef = this.$mdPanel.create(config);
                this.MdPanelRef.open();


            },
            showAddClientDialog: function ($event) {
                $event.stopImmediatePropagation();
                this.$timeout(angular.bind(this, function () {
                    this.showClientDialog({
                        $event: $event
                    });
                }), 100);

            },
            showEditClientDialog: function ($event, client) {
                $event.stopImmediatePropagation();
                this.$timeout(angular.bind(this, function () {
                    this.showClientDialog({
                        $event: $event,
                        client: client
                    });
                }), 100);
            }
        };
        ClientSelectorCtrl.$inject = [
            '$scope',
            '$mdDialog',
            'MKioskService',            
            '$timeout',
            '$mdPanel',
            '$q',
            '$timeout',
            '$translationService',            
            'client',
            'options'
        ];
        return ClientSelectorCtrl;
    }());
    angular.module('shared.clientsselector-v2', []).controller('ClientSelectorV2Ctrl', ClientSelectorCtrl);
})();


